
export { getItalianMunicipalities } from "./lib/utils/fiscal-code/fiscal-code"
export { getItalianProvinces } from "./lib/utils/fiscal-code/fiscal-code"